import React from 'react';
import './CardPrintingsContainer.css';

interface CardPrintingsContainerProps {
  children?: React.ReactNode;
}

const CardPrintingsContainer: React.FC<CardPrintingsContainerProps> = ({ children }) => {
  return <div className="card-printings-container">{children}</div>;
};

export default CardPrintingsContainer;
